import { Filter } from 'types';
import { CheckRadioGroupInfo } from '../../../../../types';
import { CheckRadioGroupListV2 } from '../../../../molecules/CheckRadioGroupListV2';

export interface IProps {
  filter: Filter;
  list: CheckRadioGroupInfo[];
  active?: string;
}

export interface IDispatchProps {
  saveFilter: (key: string, values: string[]) => void;
}

export const SelectOne = ({ filter, list, saveFilter, active }: IProps & IDispatchProps) => {
  const onChange = (value: string) => {
    saveFilter(filter.key!, [value]);
  };
  return <CheckRadioGroupListV2 radioListValue={active} items={list} onChange={onChange} />;
};
